import React, { useContext, useState } from "react";
// import CloseIcon from "@mui/icons-material/Close";
import { Dialog, makeStyles } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import CloseIcon from "@mui/icons-material/Close";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Typography
} from "@mui/material";
import jwt_decode from "jwt-decode";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { updatePassword } from "../../slices/User/UserSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import CustomTextfield from "../CustomInputs/CustomTextfield";
import CancelButtons from "../DialogBoxComponent/CancelButtons";
import SubmitButtons from "../DialogBoxComponent/SubmitButtons";
import Toast from "../ToastContainer/CustomToast";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "20px",
    minWidth: "600px",
  },
}));

export default function ChangePasswordDialog(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [showPassword, setShowPassword] = React.useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { onSubmit, children, onClose, ...other } = props;
  const [payload, setPayload] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const { darkMode } = useContext(ThemeContext);
  const handleCurrentPassword = () =>
    setShowCurrentPassword(!showCurrentPassword);
  const handleNewPassword = () => setShowNewPassword(!showNewPassword);
  const handleConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClose = () => {
    props.onClose(false);
  };

  const handleChange = (event) => {
    setPayload({
      ...payload,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = () => {
    if (CommonUtil.isEmptyString(payload.currentPassword)) {
      Toast(t("CURRENTPASSWORDEMPTY"), "error");
      return;
    }

    if (
      !payload.currentPassword.match(
        /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/
      )
    ) {
      Toast(t("CURRENTPASSWORDERROR"), "error");
      return;
    }

    if (CommonUtil.isEmptyString(payload.newPassword)) {
      Toast(t("NEWPASSWORDEMPTY"), "error");
      return;
    }
    if (
      !payload.newPassword.match(
        /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/
      )
    ) {
      Toast(t("NEWPASSWORDERROR"), "error");
      return;
    }

    if (CommonUtil.isEmptyString(payload.confirmPassword)) {
      Toast(t("CONFIRMPASSWORDEMPTY"), "error");
      return;
    }
    if (
      !payload.confirmPassword.match(
        /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()+=-\?;,./{}|\":<>\[\]\\\' ~_]).{8,}/
      )
    ) {
      Toast(t("CONFIRMPASSWORDERROR"), "error");
      return;
    }
    if (payload.newPassword !== payload.confirmPassword) {
      Toast(t("PASSWORDMATCHERROR"), "error");
      return;
    }
    if (payload.currentPassword === payload.newPassword) {
      Toast(t("SAMEPASSWORDERROR"), "error");
      return;
    }
    var decoded_jwtToken = jwt_decode(
      localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN)
    );
    let dto = {
      oldPassword: payload.currentPassword,
      newPassword: payload.newPassword,
      userId: decoded_jwtToken.userId,
    };
    dispatch(updatePassword(dto))
      .unwrap()
      .then((res) => {
        if (res.code === "UASI0005") {
          Toast(res.message, "success");
          handleClose();
          return;
        } else {
          Toast(res.message, "error");
          return;
        }
      });
  };

  return (
    <>
      <Dialog
        classes={{ paper: classes.dialogPaper }}
        {...props}
        open={props.open}
        PaperProps={{
          style: {
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
            color: darkMode ? "#fff" : "#434547",
          },
        }}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
        }}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle
          variant="h4"
          style={{ color: darkMode ? "#fff" : "black" }}
        >
          <IconButton
            onClick={handleClose}
            aria-label="close"
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          {props.Header}
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />

        <DialogContent
          sx={{
            "&.MuiDialogContent-root": {
              padding: "16px 24px",
            },
          }}
        >
          <Grid container spacing={1.8}>
            <Grid item xs={12}>
              <Typography
                sx={{
                  color: darkMode ? "#fff" : "#3D4977",
                  opacity: 0.8,
                }}
              >
                {t("CHANGE_PASSWORD_TEXT")}
              </Typography>
            </Grid>
            
            <Grid item xs={12}>
              <CustomTextfield
                id="currentPassword"
                label={t("CHEANGE_PASSWORD_LABLE_1")}
                name="currentPassword"
                variant="outlined"
                type={showCurrentPassword ? "text" : "password"}
                autoComplete="new-password"
                handleChange={handleChange}
                value={payload.currentPassword}
                inputProps={{ maxLength: 25 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        className={darkMode ? "changePassword" : "PasswordIcon"}
                        onClick={handleCurrentPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showCurrentPassword ? (
                          <Visibility
                            className={
                              darkMode
                                ? "changePasswordvisibleIconsDark"
                                : "visibleIcons"
                            }
                          />
                        ) : (
                          <VisibilityOff
                            className={
                              darkMode
                                ? "changePasswordvisibleOffIcon"
                                : "visibleIcons"
                            }
                            style={{ transform: "scaleX(-1)" }}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <CustomTextfield
                id="newPassword"
                label={t("CHANGE_PASSWORD_LABLE_2")}
                name="newPassword"
                variant="outlined"
                type={showNewPassword ? "text" : "password"}
                autoComplete="new-password"
                handleChange={handleChange}
                value={payload.newPassword}
                inputProps={{ maxLength: 25 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        className={darkMode ? "changePassword" : "PasswordIcon"}
                        onClick={handleNewPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showNewPassword ? (
                          <Visibility
                            className={
                              darkMode
                                ? "changePasswordvisibleIconsDark"
                                : "visibleIcons"
                            }
                          />
                        ) : (
                          <VisibilityOff
                            className={
                              darkMode
                                ? "changePasswordvisibleOffIcon"
                                : "visibleIcons"
                            }
                            style={{ transform: "scaleX(-1)" }}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <CustomTextfield
                id="confirmPassword"
                label={t("CHANGE_PASSWORD_LABLE_3")}
                name="confirmPassword"
                variant="outlined"
                type={showConfirmPassword ? "text" : "password"}
                autoComplete="new-password"
                handleChange={handleChange}
                value={payload.confirmPassword}
                inputProps={{ maxLength: 25 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        className={darkMode ? "changePassword" : "PasswordIcon"}
                        onClick={handleConfirmPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showConfirmPassword ? (
                          <Visibility
                            className={
                              darkMode
                                ? "changePasswordvisibleIconsDark"
                                : "visibleIcons"
                            }
                          />
                        ) : (
                          <VisibilityOff
                            className={
                              darkMode
                                ? "changePasswordvisibleOffIcon"
                                : "visibleIcons"
                            }
                            style={{ transform: "scaleX(-1)" }}
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "center",
            display: "flex",
            flexDirection: "row",

            backgroundColor: darkMode ? "#0E2A41" : "#fff",
          }}
        >
          <CancelButtons onClick={handleClose}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {props.cancelText}
            </Typography>
          </CancelButtons>

          <SubmitButtons onClick={handleSubmit} type="submit">
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {props.acceptText}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </>
  );
}
